<template>
<div class="form-step-item">
    <div class="panel">
        <div class="intro">
            <h3>Terms and Conditions</h3>
        </div>
        <div class="form-row">
            <div class="form-group col-12">
                <div class="bax-checkbox">
                    <input type="checkbox" id="terms_1" class="css-checkbox" v-model="formData.terms_1" checked="" />
                    <label class="css-label" for="terms_1">HPNer would like to receive an SMS reminder for consumables stocktakes to be completed and orders to be placed.</label>
                </div>
            </div>
            <div class="form-group col-12">
                <div class="bax-checkbox">
                    <input type="checkbox" id="terms_2" class="css-checkbox" v-model="formData.terms_2" checked="" />
                    <label class="css-label" for="terms_2">HPNer consents to phone number being included on delivery consignments.</label>
                </div>
            </div>
            <div class="form-group col-12">
                <div class="bax-checkbox">
                    <input type="checkbox" id="terms_3" class="css-checkbox" v-model="formData.terms_3" checked="" />
                    <label class="css-label" for="terms_3">HPNer agrees to be at the nominated delivery address on the arranged delivery days for HPN and consumables. *</label>
                    <span class="form-error" v-if="$v.formData.terms_3.$dirty && !$v.formData.terms_3.sameAs">Required field</span>
                </div>
            </div>
            <div class="form-group col-12">
                <div class="bax-checkbox">
                    <input type="checkbox" id="terms_4" class="css-checkbox" v-model="formData.terms_4" checked="" />
                    <label class="css-label" for="terms_4">Hospital and HPNer are aware of and agree to Equipment On Loan Terms and Conditions. *</label>
                    <span class="form-error" v-if="$v.formData.terms_4.$dirty && !$v.formData.terms_4.sameAs">Required field</span>
                </div>
            </div>
            <div class="form-group col-12 terms-copy">
                <p>The Hospital, by its authorised representative, requests (as relevant) Baxter Healthcare Pty Limited or Baxter Healthcare Limited (each "Baxter") to loan that Equipment listed above for use by the Patient subject to and in accordance with the Equipment loan terms and conditions accessible electronically on Baxter's web site at <a href="https://www.baxterhealthcare.com.au/" target="_blank" rel="noopener noreferrer">www.baxterhealthcare.com.au</a> and clicking on the 'Equipment Loan Terms' tab for Australia and New Zealand. </p>
                <p>The provision of this Request constitutes acceptance of those terms and conditions by the Hospital. If the Hospital has a separate Supply or Service Agreement signed by Baxter and currently governing these arrangements, the terms and conditions contained in that other agreement applicable to the supply of this Equipment will prevail to the extent of any inconsistency. </p>
                <p>It should be noted that if an IV Pole, Back Pack or Trolley are included in this Request, they will not be supplied under the Equipment loan terms and conditions and title will be transferred to the Hospital as free of charge Deliverables under the terms of the Contract (unless the Contract provides for a charge).</p>
            </div>
        </div>

        <div class="print-notice">
            <span class="icon"></span><strong>Important!</strong>If you require a record of this submission<strong>please print before submitting the form</strong>
        </div>
    </div>
</div>
</template>


<script>

import { sameAs } from 'vuelidate/lib/validators';

export default {
    name: 'FormStep8',
    components: {
    },
    props: {
        formData: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    validations: {
        formData: {
            terms_3: {
                sameAs: sameAs(() => true),
            },
            terms_4: {
                sameAs: sameAs(() => true),
            },
        },
    },
    computed: {
    },
    methods: {
        validateForm() {
            this.$v.$touch();
            this.$emit('validation_response', !this.$v.$invalid);
        },
    },
};
</script>
